/* PhoneModelEoxFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");
const _ = require("lodash");

class PagingPhoneModelEoxFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedPhoneModelEoxesFeed(
            this._filter,
            this._entityFields,
            this._sort,
            {skip: 0, limit: this._pageSize * 2}
        );
    }

    _feedShutDown() {
        if (_.isUndefined(this._EntityDef)) {
            return Promise.resolve();
        } else {
            return this._EntityDef.stopRelatedPhoneModelEoxesFeed();
        }
    }
}

module.exports = PagingPhoneModelEoxFeed;
